import { getRecords, bySlug } from './baserow'

export default {
  getProjects () {
    return getRecords('Papers')
  },
  getProject (slug) {
    return getRecords('Papers', bySlug(slug))
  }
}
